import React from 'react'

// 我们的团队
const Text = (props) => {
  return [{
    uid: 'text',
    html:(
      <div className="section-text">
        <div className="container">
          {props.paragraph.content}
        </div>
      </div>
    )
  }]
}

export default Text


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/text/index.js